module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("添加商品")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "productForm",
    attrs: {
      "label-width": "150px",
      "model": _vm.productForm,
      "rules": _vm.addProductRules
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h2', [_vm._v("商品分类：")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择商品分类",
      "prop": "categoryId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分类"
    },
    model: {
      value: (_vm.productForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "categoryId", $$v)
      },
      expression: "productForm.categoryId"
    }
  }, _vm._l((_vm.catogreyArr), function(item) {
    return _c('el-option', {
      key: item.categoryId,
      attrs: {
        "label": item.name,
        "value": item.categoryId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品标签"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "placeholder": "标签"
    },
    model: {
      value: (_vm.topic),
      callback: function($$v) {
        _vm.topic = $$v
      },
      expression: "topic"
    }
  }, _vm._l((_vm.topicArr), function(item) {
    return _c('el-option', {
      key: item.tagId,
      attrs: {
        "label": item.name,
        "value": item.tagId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h2', [_vm._v("基本信息：")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品名"
    },
    model: {
      value: (_vm.productForm.name),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "name", $$v)
      },
      expression: "productForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品描述"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品描述"
    },
    model: {
      value: (_vm.productForm.description),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "description", $$v)
      },
      expression: "productForm.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品押金(单位：分)",
      "prop": "deposit"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品押金"
    },
    model: {
      value: (_vm.productForm.deposit),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "deposit", $$v)
      },
      expression: "productForm.deposit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "起租的每日租金(单位：分)",
      "prop": "rental"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "起租的每日租金"
    },
    model: {
      value: (_vm.productForm.rental),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "rental", $$v)
      },
      expression: "productForm.rental"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原租金价格(单位：分)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "原租金价格"
    },
    model: {
      value: (_vm.productForm.oldRental),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "oldRental", $$v)
      },
      expression: "productForm.oldRental"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "起租天数设置",
      "prop": "minimumDay"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "起租天数设置"
    },
    model: {
      value: (_vm.productForm.minimumDay),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "minimumDay", $$v)
      },
      expression: "productForm.minimumDay"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "后续价格(单位：分)",
      "prop": "rentalMore"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "后续价格"
    },
    model: {
      value: (_vm.productForm.rentalMore),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "rentalMore", $$v)
      },
      expression: "productForm.rentalMore"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传商品橱窗图片"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "https://upload.qiniup.com/",
      "on-error": _vm.handleError,
      "list-type": "picture-card",
      "on-preview": _vm.handlePicCardPreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handlePicSuccess,
      "before-upload": _vm.beforePicUpload,
      "data": _vm.uptoken
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "视频链接(选填)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "视频链接"
    },
    model: {
      value: (_vm.productForm.media.video),
      callback: function($$v) {
        _vm.$set(_vm.productForm.media, "video", $$v)
      },
      expression: "productForm.media.video"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传视频封面图(选填)"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "show-file-list": false,
      "action": "https://upload.qiniup.com/",
      "on-error": _vm.handleError,
      "on-remove": _vm.handleVideoRemove,
      "on-success": _vm.handleVideoSuccess,
      "before-upload": _vm.beforeDetailUpload,
      "data": _vm.uptoken
    }
  }, [(_vm.productForm.media.videoThumb) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.productForm.media.videoThumb
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品清单"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "名称"
    },
    model: {
      value: (_vm.list.name),
      callback: function($$v) {
        _vm.$set(_vm.list, "name", $$v)
      },
      expression: "list.name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    staticStyle: {
      "text-align": "center",
      "border": "0"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "数量"
    },
    model: {
      value: (_vm.list.count),
      callback: function($$v) {
        _vm.$set(_vm.list, "count", $$v)
      },
      expression: "list.count"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addList
    }
  }, [_vm._v("添加")])], 1)], 1), _vm._v(" "), (_vm.productForm.inventory.length) ? _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, _vm._l((_vm.productForm.inventory), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('p', [_vm._v(_vm._s(++index) + "、" + _vm._s(item[0]) + "*" + _vm._s(item[1]) + " "), _c('el-button', {
      staticStyle: {
        "margin-left": "20px"
      },
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.removeThis(index)
        }
      }
    }, [_vm._v("删除")])], 1)])
  }), 0) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否提供PlayCare保险服务"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.insurance),
      callback: function($$v) {
        _vm.insurance = $$v
      },
      expression: "insurance"
    }
  }, [_vm._v("提供")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.insurance),
      callback: function($$v) {
        _vm.insurance = $$v
      },
      expression: "insurance"
    }
  }, [_vm._v("不提供")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-left": "20px",
      "width": "200px"
    },
    attrs: {
      "placeholder": "如果提供请输入价格(单位：分)"
    },
    model: {
      value: (_vm.productForm.insurance),
      callback: function($$v) {
        _vm.$set(_vm.productForm, "insurance", $$v)
      },
      expression: "productForm.insurance"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传商品详情图"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "https://upload.qiniup.com/",
      "on-error": _vm.handleError,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleDetailRemove,
      "on-success": _vm.handleDetailSuccess,
      "before-upload": _vm.beforeDetailUpload,
      "data": _vm.uptoken
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选配设置"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "placeholder": "商品"
    },
    model: {
      value: (_vm.value10),
      callback: function($$v) {
        _vm.value10 = $$v
      },
      expression: "value10"
    }
  }, _vm._l((_vm.xuanpeiArr), function(item) {
    return _c('el-option', {
      key: item.productDetailId,
      attrs: {
        "label": item.name,
        "value": item.productDetailId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h2', [_vm._v("享玩甄选设置")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.zhenxuan),
      callback: function($$v) {
        _vm.zhenxuan = $$v
      },
      expression: "zhenxuan"
    }
  }, [_vm._v("默认为首页的享玩甄选")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.zhenxuan),
      callback: function($$v) {
        _vm.zhenxuan = $$v
      },
      expression: "zhenxuan"
    }
  }, [_vm._v("重新设置")])], 1), _vm._v(" "), (_vm.zhenxuan != '1') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "享玩甄选描述",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.shopForm.name),
      callback: function($$v) {
        _vm.$set(_vm.shopForm, "name", $$v)
      },
      expression: "shopForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品选择",
      "label-width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "商品"
    },
    on: {
      "change": _vm.productChoose
    },
    model: {
      value: (_vm.shopForm.productDetailId),
      callback: function($$v) {
        _vm.$set(_vm.shopForm, "productDetailId", $$v)
      },
      expression: "shopForm.productDetailId"
    }
  }, _vm._l((_vm.productArr), function(item) {
    return _c('el-option', {
      key: item.productDetailId,
      attrs: {
        "label": item.name,
        "value": item.productDetailId
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.shopForm.product) ? _c('el-form-item', {
    attrs: {
      "label": "当前租金(元)",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.shopForm.product.rental),
      callback: function($$v) {
        _vm.$set(_vm.shopForm.product, "rental", $$v)
      },
      expression: "shopForm.product.rental"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.shopForm.product) ? _c('el-form-item', {
    attrs: {
      "label": "原租金(元)",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.shopForm.product.oldRental),
      callback: function($$v) {
        _vm.$set(_vm.shopForm.product, "oldRental", $$v)
      },
      expression: "shopForm.product.oldRental"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addShop
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "50px",
      "overflow": "hidden"
    },
    attrs: {
      "label": "",
      "label-width": "150px"
    }
  }, _vm._l((_vm.productForm.pushProductDetails), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('el-card', {
      staticClass: "box-card",
      staticStyle: {
        "width": "260px",
        "margin-right": "20px",
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('span', {
      staticStyle: {
        "line-height": "36px"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.removeCard(index)
        }
      }
    }, [_vm._v("删除")])], 1), _vm._v(" "), _c('div', {
      staticClass: "text item"
    }, [_c('p', [_vm._v("当前租金：" + _vm._s(item.rental))]), _vm._v(" "), _c('p', [_vm._v("原来租金：" + _vm._s(item.oldReantal))])])])], 1)
  }), 0)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b8defd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/product/AddProduct.vue
// module id = 711
// module chunks = 1